<template>
    <v-container fluid grid-list-md>
        <v-layout column wrap>
            <v-flex>
                <h1 class="display-3">Gestión de seguros</h1>
                <br>
                <v-card>
                    <v-card-text>
                        <form @submit.prevent="agregar()" ref="form" lazy-validation>
                            <v-layout>
                                <v-flex xs12 sm2>
                                    <v-text-field label="Km desde" v-model="d.km_desde"></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm2>
                                    <v-text-field label="Km hasta" v-model="d.km_hasta"></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm2>
                                    <v-text-field label="Alícuota" v-model="d.alicuota"></v-text-field>
                                </v-flex>

                                <v-flex xs12 sm2>
                                    <v-text-field label="Valor prom m2" v-model="valPromM2" @change="setConfigVal('valPromM2',valPromM2)"></v-text-field>
                                </v-flex>
                            </v-layout>
                            <v-layout>
                                <v-flex>
                                    <v-btn type="submit" dark color="green" :loading="loading">
                                        Agregar
                                    </v-btn>
                                </v-flex>
                            </v-layout>
                        </form>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
        <v-layout>
            <v-flex>
                <v-data-table
                        :headers="headers"
                        :items="items"
                        :pagination.sync="pag"
                        :total-items="totalItems"
                        :loading="loading"
                        rows-per-page-text="Filas por pagina"
                        no-data-text="No hay datos"
                        disable-initial-sort
                        item-key="id"
                        class="tabla-compacta-col"
                >
                    <template slot="items" slot-scope="props">
                        <td class="text-xs-center">{{ props.item.km_desde }}</td>
                        <td class="text-xs-center">{{ props.item.km_hasta }}</td>
                        <td class="text-xs-right">
                            <v-edit-dialog
                                    save-text="Guardar"
                                    cancel-text="Cancelar"
                                    large
                                    lazy
                                    style="width: 100%"
                                    @save="editar(props.item)">
                                <span style="width: 100%">{{ (props.item.alicuota)?props.item.alicuota : 0  }}</span>
                                <v-text-field
                                        slot="input"
                                        v-model="alicuotaNueva"
                                        label="Editar"
                                        single-line
                                        type="number"
                                        hint="Presione <kbd>enter</kbd> para guardar"
                                >
                                </v-text-field>
                            </v-edit-dialog>
                        </td>
                        <td class="text-xs-center">
                            <v-btn flat icon @click.native="eliminar(props.item.id)" color="red" :loading="loadingDel === props.item.id">
                                <v-icon>delete</v-icon>
                            </v-btn>
                        </td>
                    </template>
                </v-data-table>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import fleteMixin from '../../mixins/flete_seguro';

    import moneda from '../../filters/moneda';
    import {mapActions} from 'vuex';

    function initialValue() {
        return {
            km_desde: '',
            km_hasta: '',
            alicuota: '',
        }
    }

    export default {
        name: "flete_seguro",
        mixins: [fleteMixin],
        filters: {moneda},
        data() {
            return {
                loading: false,
                loadingDel: -1,
                d: initialValue(),
                alicuotaNueva: 0,
                headers: [
                    {text: 'Kmts desde', value: 'km_desde', align: 'center'},
                    {text: 'Kmts hasta', value: 'km_hasta', align: 'center'},
                    {text: 'Alícuota', value: 'alicutoa', align: 'center'},
                    {text: 'Opciones', value: '', align: 'center', sortable: false},
                ],
                items: [],
                pag: {},
                totalItems: 0,
                factorOcup: 0,
                valPromM2: 0
            }
        },
        watch: {
            pag: {
                handler() {
                    this.tabla();
                },
                deep: true
            }
        },
        mounted() {

            this.configGet('valPromM2', r => {
                this.valPromM2 = r;
            }, err => console.log(err));
        },
        methods: {
            ...mapActions('notif', ['msjShow']),
            tabla() {
                this.loading = true;
                this.fleteSeguroIndex(this.pag, r => {
                    this.totalItems = r.total;
                    this.items = r.data;
                    this.loading = false;
                }, err => {
                    console.log(err);
                    this.loading = false;
                });
            },
            agregar() {
                this.loading = true;
                this.fleteSeguroStore(this.d, r => {
                    this.msjShow(r);
                    this.tabla();
                    this.d = initialValue();
                    this.loading = false;
                }, err => {
                    this.msjShow({txt: 'Error al guardar', tipo: 'error'});
                    this.loading = false;
                });
            },
            editar(item) {
                this.loading = true;
                this.fleteSeguroUpdate(item.id, {alicuota: this.alicuotaNueva}, r => {
                    this.msjShow(r);
                    item.alicuota = this.alicuotaNueva;
                    this.alicuotaNueva = '';
                    this.loading = false;
                }, err => {
                    console.error('Error');
                    this.loading = false;
                });
                return false;
            },

            eliminar(id) {
                this.loadingDel = id;
                this.fleteSeguroDestroy(id, r => {
                    this.msjShow(r);
                    this.tabla();
                    this.loadingDel = -1;
                }, err => {
                    this.msjShow({txt: 'Error al eliminar', tipo: 'error'});
                    this.loadingDel = -1;
                });
            },
        }
    }
</script>

<style>
    .v-menu__activator a {
        width: 100% !important;
        text-align: right !important;
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/pages/flete/seguro.vue